export default "__VITE_ASSET__DIUId9tZ__"